
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1CCr3", function(module, exports) {
$parcel$export(module.exports, "AddFeaturesSidebarSpotlight", () => (parcelRequire("asbHm")).AddFeaturesSidebarSpotlight);

var $asbHm = parcelRequire("asbHm");


});


//# sourceMappingURL=AddFeaturesSidebarSpotlight.66cbe1f8.js.map
